import { Component, OnInit, Input, OnDestroy } from '@angular/core';
import { interval, Subscription } from 'rxjs';

@Component({
	selector: 'portals-image-auto-carousel',
	templateUrl: './image-auto-carousel.component.html',
	styleUrls: ['./image-auto-carousel.component.scss'],
})
export class ImageAutoCarouselComponent implements OnInit, OnDestroy {
	@Input() images: string[] = ['https://jotto-imgs.s3.us-west-2.amazonaws.com/ad_2_1.png', 'https://jotto-imgs.s3.us-west-2.amazonaws.com/ad_2_2.png', 'https://jotto-imgs.s3.us-west-2.amazonaws.com/ad_2_3.png'];
	currentIndex = 0;
	currentImage: string = this.images[0];
	private subscription!: Subscription;

	ngOnInit() {
		this.currentImage = this.images[0];
		this.subscription = interval(1500).subscribe(() => {
			this.currentIndex = (this.currentIndex + 1) % this.images.length;
			this.currentImage = this.images[this.currentIndex];
		});
	}

	ngOnDestroy() {
		if (this.subscription) {
			this.subscription.unsubscribe();
		}
	}
}
